export namespace TourId {
  export enum Agency {
    create = "createAgency",
    modal = "modalAgency",
    close = "closeAgency",
    save = "saveAgency",
    overview = "overviewAgency",
  }

  export enum Route {
    create = "routeCreate",
    modal = "routeModal",
    save = "routeSave",
    close = "routeClose",
    overview = "routeOverview",
    card = "routeCard",
    cardHeader = "routeCardHeader",
    cardBody = "routeCardBody",
    cardActionTrip = "routeCardActionTrip",
    cardActionDelete = "routeCardActionDelete",
    cardActionEdit = "routeCardActionEdit",
  }

  export enum Stop {
    create = "createStop",
    modal = "modalStop",
    save = "saveStop",
    close = "closeStop",
    card = "cardStop",
  }
  export enum Trip {
    create = "createTrip",
    modal = "modalTrip",
    save = "saveTrip",
    close = "closeTrip",
    card = "cardTrip",
    overview = "overviewTrip",
    stops = "stopsTrip",
  }
}
